module.exports = __webpack_public_path__ + "/login_ui/img/ga-86c28bc8f4ccd9aa8a255fe7c8662c8c.svg";